"use client";

import { useRef } from "react";

export type RotateHandleProps = {
  onChange: (deg: number) => void;
  getCenter: () => { x: number; y: number } | null;
  initialDeg: number;
  className?: string;
  title?: string;
};

export default function RotateHandle({
  onChange,
  getCenter,
  initialDeg,
  className,
  title = "Rotate",
}: RotateHandleProps) {
  const isDraggingRef = useRef(false);
  const startAngleRef = useRef(0);
  const startDegRef = useRef(initialDeg);

  return (
    <button
      type="button"
      aria-label={title}
      title={title}
      className={className}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const center = getCenter();
        if (!center) return;
        isDraggingRef.current = true;
        startDegRef.current = initialDeg;
        startAngleRef.current = Math.atan2(
          e.clientY - center.y,
          e.clientX - center.x
        );

        function onMove(ev: MouseEvent) {
          if (!isDraggingRef.current) return;
          const c = getCenter();
          if (!c) return;
          const angle = Math.atan2(ev.clientY - c.y, ev.clientX - c.x);
          const delta = angle - startAngleRef.current;
          let deg = (startDegRef.current + (delta * 180) / Math.PI) % 360;
          if (deg < 0) deg += 360;
          onChange(deg);
        }
        function onUp() {
          isDraggingRef.current = false;
          window.removeEventListener("mousemove", onMove);
          window.removeEventListener("mouseup", onUp);
        }
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);
      }}
    />
  );
}
